import { boxShadows } from '@eversports/design-tokens/box-shadows'
import Box from '@eversports/klimt-primitives/legacy/Box'
import * as React from 'react'

interface Props {
  variant?: 'default' | 'dense'
  onClick?: () => void
}

const SectionCard = ({ children, onClick, variant = 'default' }: React.PropsWithChildren<Props>) => {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        border: '1px solid',
        borderColor: 'mediumgray',
        boxShadow: boxShadows.default,
        paddingY: variant === 'dense' ? 4 : 6,
        borderRadius: 1,
        paddingX: 4,
      }}
      onClick={onClick}
    >
      {children}
    </Box>
  )
}

export default SectionCard
